export default "__VITE_ASSET__e41ad2b8__"